import { render, staticRenderFns } from "./ProductionBatchCreator.vue?vue&type=template&id=6bdaf25c&scoped=true"
import script from "./ProductionBatchCreator.vue?vue&type=script&lang=js"
export * from "./ProductionBatchCreator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdaf25c",
  null
  
)

export default component.exports